import { useEffect } from 'react';

import { registerNetworkListener } from './NetworkProvider';

export function useNetworkListener({
  onDisconnect,
  onReconnect,
}: {
  onDisconnect?: () => void;
  onReconnect?: () => void;
}) {
  useEffect(() => {
    const unregister = registerNetworkListener({
      onOnline: onReconnect,
      onOffline: onDisconnect,
    });

    return () => {
      unregister();
    };
  }, [onDisconnect, onReconnect]);
}
